function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M256 64.5c51.1 0 99.2 19.9 135.4 56.1s56.1 84.2 56.1 135.4-19.9 99.2-56.1 135.4-84.2 56.1-135.4 56.1-99.2-19.9-135.4-56.1C84.5 355.2 64.5 307.1 64.5 256s19.9-99.2 56.1-135.4c36.2-36.1 84.3-56.1 135.4-56.1m0-16.5C141.1 48 48 141.1 48 256s93.1 208 208 208 208-93.1 208-208S370.9 48 256 48z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M352 160l-223.7 96H256v128z"
});

function SvgIosNavigateOutline({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIosNavigateOutline);
export default __webpack_public_path__ + "static/media/ios-navigate-outline.70e63c3f.svg";
export { ForwardRef as ReactComponent };